<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Office of the Executive Treasurer 💰</h1>
        <h4>The Office of the Executive Treasurer is responsible for setting and enforcing the proper financial documentation standards for all of the organization’s activities and events. This includes safeguarding, allocating, controlling, and accounting for the flow of money within the organization, and at the same time, initiating and supervising all fund-raising activities of the organization. Moreover, the Executive Treasurer prepares and presents monthly and periodic budget reports to be presented to the Executive Board, financial statements, and other documents of the organization, and conducts bank transactions for all the financial resources of the organization. The office acts as an intermediary for monetary concerns between all clusters and offices and works closely with the Office of School Activities and the Central Accounting Office.</h4>

        <h3>Positions:</h3>
        
        <h2><b> OET Officer </b></h2>
        <h4>All OET Officers rotate between two sub-clusters to allow each officer to be well-versed in each aspect necessary in the cluster, thus giving each OET Officer the roles as Project Treasurer / Finance Officer. Each OET Officer will be assigned to a specific sub-cluster depending on the Executive Treasurer’s discretion in aligning the rotation period to MISA’s calendar of events.</h4>

        <h3><b>Project Treasurer</b></h3>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Trains under the Associate for Treasury and the Executive Treasurer</li>
            <li>Handles the finances for their respective projects assigned to them. These include:
                <ul>
                    <li>keeping receipts for all transactions done for the projects</li>
                    <li>submitting a budget plan</li>
                    <li>creating and updating the events’ budget reports to be submitted to the Office of the Executive Treasurer through the office’s Google Drive folder</li>
                </ul>
            </li>
            <li>Expected to be punctual with their reports, responsive with their updates once or twice a week, and responsible with the financial possessions (e.g. money) and official receipts of expenses</li>
            <li>Expected to value communication and openness to the office and other clusters. This is to handle other transactions done by other clusters if possible</li>
        </ul>

        <h3><b>Finance Officer  </b></h3>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Trains under the Associate for Treasury and the Executive Treasurer</li>
            <li>Handles the moving of the finances involved with the fundraiser of their committee
                <ul>
                    <li>keeping receipts for all transactions done for the fundraiser</li>
                    <li>submitting a budget plan</li>
                    <li>creating and updating the fundraiser’s budget reports to be submitted to the Office of the Executive Treasurer through the office’s Google Drive folder</li>
                </ul>
            </li>
            <li>Facilitates the implementation of the fundraiser within their specific project</li>
            <li>Helps the Associate for Finance in looking for potential suppliers</li>
        </ul>
       
        <!-- <h2><b>Associate for Treasury (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul
            <li>Oversees the allocation and spending of the organization’s budget</li>
            <li>Collects and files proper financial documentation for administrative filing</li>
            <li>Acts as the secondary intermediary for financial matters between the organization and the Office of Student Activities (OSA)</li>
            <li>Assumes the position of the third-level officer/s whom he or she manages if there are no applications for the aforementioned position</li>
            <li>Ensures that the OET BETA, third-level OET officers, members, and external stakeholders, if applicable, are informed regarding the rescheduling or cancellation of OET initiative/s in cases when natural or man-made disasters occur a few days before or during the day of the initiative itself</li>
            <li>Trains, oversees, deploys, and communicates with the third-level officers of the sub-office and serves as the bridge between the third-level officers and the Executive Treasurer</li>
        </ul>

        <h2><b>Associate for Finance (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Oversees the organization’s fundraising efforts which includes conceptualizing, organizing, and managing events towards the fulfillment of this goal</li>
            <li>Assumes the position of the third-level officer/s whom he or she manages if there are no applications for the aforementioned position</li>
            <li>Ensures that the OET BETA, third-level OET officers, members, and external stakeholders, if applicable, are informed regarding the rescheduling or cancellation of OET initiative/s in cases when natural or man-made disasters occur a few days before or during the day of the initiative itself</li>
            <li>Trains, oversees, deploys, and communicates with the third-level officers of the sub-office and serves as the bridge between the third-level officers and the Executive Treasurer</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerOET'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>
